<template functional>
    <b-card
        :class="`alert-card${
            props.selected ? ' alert-selected ' : ' '
        }shadow-sm h-100 py-2 cursor-pointer border-${props.variant}`"
        @click="listeners['select']"
    >
        <b-row no-gutters align-v="center">
            <b-col class="mr-2">
                <div
                    class="text-xs font-weight-bold text-secondary text-uppercase mb-1"
                >
                    {{ props.title }}
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">
                    {{ props.total }}
                </div>
            </b-col>
            <b-col cols="auto">
                <i :class="`fas ${props.icon} fa-2x text-${props.variant}`" />
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
export default {
    name: "AlertCard",
    props: {
        title: {
            type: String,
            default: "críticos"
        },
        icon: {
            type: String,
            default: "fa-times-circle"
        },
        total: {
            type: Number,
            default: 0
        },
        variant: {
            type: String,
            default: "danger",
            validator(value) {
                return ["danger", "warning", "info"].includes(value);
            }
        },
        selected: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped>
.alert-card {
    &.alert-selected {
        &.border-warning {
            box-shadow: 0 0 2px 5px rgba($warning, 0.33) !important;
        }
        &.border-danger {
            box-shadow: 0 0 2px 5px rgba($danger, 0.33) !important;
        }
        &.border-info {
            box-shadow: 0 0 2px 5px rgba($info, 0.33) !important;
        }
    }
}
</style>
